import { styled, css } from 'styled-components'
import { MinusIcon, PlusIcon } from '../../../../../icons'

export const Controls = styled.div`
  display: flex;
  gap: 2px;
  transform: translateX(2px);
`

export const Control = styled.div<{
  $direction: 'left' | 'right'
  $disabled?: boolean
}>`
  width: 32px;
  height: 25px;
  background-color: #ededed;
  display: flex;
  align-items: center;
  cursor: pointer;

  ${({ $direction }) =>
    $direction === 'left'
      ? css`
          border-radius: 41px 0 0 41px;
        `
      : css`
          border-radius: 0 41px 41px 0;
        `}
  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.3;
      pointer-events: none;
    `}
}
`

export const Plus = styled(PlusIcon)`
  width: 12px;
  height: 12px;
  margin-left: 8px;
`

export const Minus = styled(MinusIcon)`
  width: 12px;
  height: 12px;
  margin-left: 12px;
`
